import script from "./FileUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUploader.vue?vue&type=script&setup=true&lang=js"

import "./FileUploader.vue?vue&type=style&index=0&id=7197b5ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7197b5ee"]])

export default __exports__